module.exports = __webpack_public_path__ + "img/businessThree.91f8ce16.svg";